import React, { useCallback } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'
import { useAccessInvitationDialog } from 'src/Libs/installation-rights-management/hooks'
interface Props {
  item: InstallationInvitationModel
  onConfirm: (item: InstallationInvitationModel) => void
}
const InvitationStatusIndicatorColumn: React.FC<Props> = ({ item, onConfirm }) => {
  const { t } = useCustomTranslation()
  const { resend } = useAccessInvitationDialog(item)

  const handleResendClick = useCallback(() => {
    resend().then(() => onConfirm(item))
  }, [item, onConfirm, resend])

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'center'} spacing={2}>
      <Typography variant={'body2'}>
        {item.expiredAt
          ? t('installation.access-and-invitations.table.columns.expired')
          : t('installation.access-and-invitations.table.columns.invited')}
      </Typography>
      {!item.expiredAt && <Button onClick={handleResendClick}>{t('installation.access-and-invitations.table.columns.resend-invite')}</Button>}
    </Stack>
  )
}

export default InvitationStatusIndicatorColumn
